import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionSection from './components/SolutionSection';
import ServicesSection from './components/ServicesSection';
import GlobalSection from './components/GlobalSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import PartnersSection from './components/PartnersSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { SchemaOrg, organizationSchema, websiteSchema, webPageSchema, faqSchema } from '@/utils/seo';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={webPageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      
      <Header />
      <HeroSection />
      <ProblemsSection />
      <SolutionSection />
      <ServicesSection />
      <GlobalSection />
      <StatsSection />
      <TestimonialsSection />
      <PartnersSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
